import { useEffect, useState } from "react";

import type { DeferRenderProps } from "./types";

export function DeferRender({ seconds, children }: DeferRenderProps) {
  const [render, setRender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setRender(true), seconds * 1000);
    return () => clearTimeout(timer);
  }, [seconds]);

  return render ? children : null;
}
